import * as React from 'react'

import { ColorUnion, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Complaint from 'modules/complaints/store/models/Complaint'

interface Props {
  complaint: Complaint
}

function ComplaintStatusTag({ complaint }: Props) {
  const statuses: Record<string, { type: ColorUnion; text: string }> = {
    acknowledged: {
      type: 'champagne',
      text: i18n.t('complaints.status.in_progress'),
    },
    created: {
      type: 'purple',
      text: i18n.t('complaints.status.created'),
    },
    completed: {
      type: 'lime',
      text: i18n.t('complaints.status.processed'),
    },
    discarded: {
      type: 'grey',
      text: i18n.t('complaints.status.discarded'),
    },
  } as const

  const status = complaint.status
  const item = statuses[status]

  if (!item) {
    throw new Error(`Unknown status: ${status}`)
  }

  const { type, text } = item

  return <Tag type={type}>{text}</Tag>
}

export default observer(ComplaintStatusTag)
